// Country dial codes used by the WhatsApp OTP fields.
// `code` is the numeric dial code string Blexbot expects for `country_code`
// (e.g. "1" for USA, "52" for Mexico) — NOT ISO-3166 alpha-2.
// `iso` is kept only for the flag/name label.
export const COUNTRY_CODES = [
  { iso: "US", code: "1",   name: "United States",      dial: "+1",   flag: "🇺🇸" },
  { iso: "CA", code: "1",   name: "Canada",             dial: "+1",   flag: "🇨🇦" },
  { iso: "MX", code: "52",  name: "Mexico",             dial: "+52",  flag: "🇲🇽" },
  { iso: "GT", code: "502", name: "Guatemala",          dial: "+502", flag: "🇬🇹" },
  { iso: "SV", code: "503", name: "El Salvador",        dial: "+503", flag: "🇸🇻" },
  { iso: "HN", code: "504", name: "Honduras",           dial: "+504", flag: "🇭🇳" },
  { iso: "NI", code: "505", name: "Nicaragua",          dial: "+505", flag: "🇳🇮" },
  { iso: "CR", code: "506", name: "Costa Rica",         dial: "+506", flag: "🇨🇷" },
  { iso: "PA", code: "507", name: "Panama",             dial: "+507", flag: "🇵🇦" },
  { iso: "CO", code: "57",  name: "Colombia",           dial: "+57",  flag: "🇨🇴" },
  { iso: "VE", code: "58",  name: "Venezuela",          dial: "+58",  flag: "🇻🇪" },
  { iso: "EC", code: "593", name: "Ecuador",            dial: "+593", flag: "🇪🇨" },
  { iso: "PE", code: "51",  name: "Peru",               dial: "+51",  flag: "🇵🇪" },
  { iso: "BO", code: "591", name: "Bolivia",            dial: "+591", flag: "🇧🇴" },
  { iso: "PY", code: "595", name: "Paraguay",           dial: "+595", flag: "🇵🇾" },
  { iso: "UY", code: "598", name: "Uruguay",            dial: "+598", flag: "🇺🇾" },
  { iso: "AR", code: "54",  name: "Argentina",          dial: "+54",  flag: "🇦🇷" },
  { iso: "CL", code: "56",  name: "Chile",              dial: "+56",  flag: "🇨🇱" },
  { iso: "BR", code: "55",  name: "Brazil",             dial: "+55",  flag: "🇧🇷" },
  { iso: "DO", code: "1",   name: "Dominican Republic", dial: "+1",   flag: "🇩🇴" },
  { iso: "PR", code: "1",   name: "Puerto Rico",        dial: "+1",   flag: "🇵🇷" },
  { iso: "ES", code: "34",  name: "Spain",              dial: "+34",  flag: "🇪🇸" },
  { iso: "PT", code: "351", name: "Portugal",           dial: "+351", flag: "🇵🇹" },
  { iso: "GB", code: "44",  name: "United Kingdom",     dial: "+44",  flag: "🇬🇧" },
  { iso: "FR", code: "33",  name: "France",             dial: "+33",  flag: "🇫🇷" },
  { iso: "DE", code: "49",  name: "Germany",            dial: "+49",  flag: "🇩🇪" },
  { iso: "IT", code: "39",  name: "Italy",              dial: "+39",  flag: "🇮🇹" },
];

// Best-effort resolver. Accepts either the numeric dial code (e.g. "1") or an
// ISO-2 code (e.g. "US"). Falls back to the first entry.
export const findCountry = (value) => {
  if (!value) return COUNTRY_CODES[0];
  const s = String(value);
  return (
    COUNTRY_CODES.find((c) => c.code === s) ||
    COUNTRY_CODES.find((c) => c.iso === s.toUpperCase()) ||
    COUNTRY_CODES[0]
  );
};
